import { useTranslation } from '../../i18n';
import React from 'react';
import RunningPhysiologicalChart from '../Running/RunningPhysiologicalChart';
import { interpretTTE, interpretTAE } from '../../utils/interpretTraining';

const convertDurationToMinutes = (durationStr) => {
  if (!durationStr || typeof durationStr !== 'string') return 0;
  const parts = durationStr.split(':');
  if (parts.length !== 3) return 0;
  const [hours, minutes, seconds] = parts.map(Number);
  return (hours * 60) + minutes + (seconds / 60);
};

const RunningPhysiologicalAnalysis = ({ completed = {}, metrics = {}, athleteId, activityId, banister, date }) => {
  const { t, language } = useTranslation();
  if (!completed || Object.keys(completed).length === 0) return null;
  const tx = (key, values) => t(`athleteDashboard.runningPhysio.${key}`, values);
  const vo2 = parseFloat(completed.vo2max);
  const tss = parseFloat(completed.tss);
  const durationMin = convertDurationToMinutes(completed?.duracion);
  const tea = parseFloat(completed.tea);
  const tte = parseFloat(completed.tte);
  const vo2Safe = isNaN(vo2) ? 0 : vo2;
  const tssSafe = isNaN(tss) ? 0 : tss;
  const teaSafe = isNaN(tea) ? 0 : tea;
  const tteSafe = isNaN(tte) ? 0 : tte;

  return (
    <div className="p-4 shadow-sm mb-4 rounded bg-white">
      {/* 1. Resumen Visual de Métricas Fisiológicas */}
      <h6 className="mb-2" style={{ color: '#193255', fontSize: 14, fontWeight: 700 }}>
        {tx('chartTitle')}
      </h6>
      <RunningPhysiologicalChart
        completed={{ ...completed, vo2max: vo2Safe, tss: tssSafe, tea: teaSafe, tte: tteSafe }}
      />

      {/* 2. Análisis Fisiológico de la Sesión */}
      <h5 className="mt-4 mb-3" style={{ color: '#193255', fontSize: 14, fontWeight: 700 }}>
        {tx('title')}
      </h5>

      <p>{tx('vo2Sentence', { value: vo2Safe.toFixed(2) })}</p>

      <p>
        {tx('tssSentence', {
          tss: tssSafe.toFixed(2),
          duration: durationMin.toFixed(2),
          load: tssSafe > 100 ? tx('loadHigh') : tx('loadModerate')
        })}
      </p>

      {completed.frecuenciaCardiacaPromedio > 0 && (
        <p>
          {tx('hrSentence', {
            avg: completed.frecuenciaCardiacaPromedio,
            max: completed.frecuenciaCardiacaMaxima
          })}
        </p>
      )}

      {completed.normalizedPower && (
        <p>{tx('npSentence', { value: completed.normalizedPower.toFixed(2) })}</p>
      )}

      {completed.potenciaPromedio && (
        <p>{tx('avgPowerSentence', { value: completed.potenciaPromedio.toFixed(2) })}</p>
      )}

      {completed.potenciaMaxima && (
        <p>{tx('maxPowerSentence', { value: completed.potenciaMaxima.toFixed(2) })}</p>
      )}

      {completed.ftp && (
        <p>{tx('ftpSentence', { value: completed.ftp.toFixed(2) })}</p>
      )}

      {!isNaN(tteSafe) && (
        <p>
          {tx('tteSentence', { value: tteSafe })} <em>{interpretTTE(tteSafe, language)}</em>
        </p>
      )}

      {!isNaN(teaSafe) && (
        <p>
          {tx('teaSentence', { value: teaSafe })} <em>{interpretTAE(teaSafe, language)}</em>
        </p>
      )}


    </div>
  );
};

export default RunningPhysiologicalAnalysis;
